import A from './ActionCreators';
import { v4 } from 'uuid';
import hasSimpleImageFileExtension from './hasSimpleImageFileExtension';
export default function onUploadFilesSelected(files,dispatch){

  let urls = files.map(URL.createObjectURL)





  let mimes = files.map(f => f.type);
  console.log("MIMES",mimes);
  let filenames = files.map( f => f.name );
  let imageSetIds = files.map( _ => v4() );
  let imageIds = files.map( _ => v4() );

  /*
  dispatch(A.uploadFiles({
    filenames,
    urls,
    storageLocation:"fake",
  }))
  */


  let breakdown = {
    simple:{
      mimes:[],
      filenames:[],
      imageSetIds:[],
      imageIds:[],
      urls:[],
    },
    complex:{
      mimes:[],
      filenames:[],
      imageSetIds:[],
      imageIds:[],
      urls:[],
    }
  }

  files.forEach((f,ii) => {
    let toAppend;

    if( hasSimpleImageFileExtension(f.name.toLowerCase()) ){
      toAppend = breakdown.simple;
    }else{
      toAppend = breakdown.complex;
    }


    toAppend.mimes.push(f.type);
    toAppend.filenames.push(f.name);
    toAppend.imageSetIds.push(v4());
    toAppend.imageIds.push(v4());
    toAppend.urls.push(urls[ii]);

  })

  if( breakdown.simple.filenames.length > 0 ){

    dispatch(A.startImageUploads({
      filenames,
      imageSetIds, 
      imageIds, 
      urls, 
      convertTo:"png", 
      storageLocation:"s3"
    }))

  }

  if( breakdown.complex.filenames.length > 0 ){
    dispatch(A.startImageUploads({
      filenames,
      imageSetIds, 
      imageIds, 
      urls, 
      //convertTo:"png", 
      storageLocation:"s3"
    }))
  }

}
